var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRobot403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13235",
    "data-name": "Group 13235",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 585.67,
    height: 472.385,
    viewBox: "0 0 585.67 472.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31646",
    "data-name": "Rectangle 31646",
    width: 585.67,
    height: 472.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31645",
    "data-name": "Rectangle 31645",
    width: 585.672,
    height: 472.385,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31590",
    "data-name": "Rectangle 31590",
    width: 53.478,
    height: 26.575,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31591",
    "data-name": "Rectangle 31591",
    width: 36.072,
    height: 70.628,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31592",
    "data-name": "Rectangle 31592",
    width: 27.957,
    height: 20.789,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31593",
    "data-name": "Rectangle 31593",
    width: 1.349,
    height: 5.539,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31594",
    "data-name": "Rectangle 31594",
    width: 6.101,
    height: 1.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31595",
    "data-name": "Rectangle 31595",
    width: 5.488,
    height: 1.908,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31596",
    "data-name": "Rectangle 31596",
    width: 4.472,
    height: 4.01,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31597",
    "data-name": "Rectangle 31597",
    width: 5.09,
    height: 3.475,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31598",
    "data-name": "Rectangle 31598",
    width: 0.962,
    height: 5.502,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31599",
    "data-name": "Rectangle 31599",
    width: 5.996,
    height: 2.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31600",
    "data-name": "Rectangle 31600",
    width: 5.368,
    height: 2.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31601",
    "data-name": "Rectangle 31601",
    width: 4.832,
    height: 3.509,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31602",
    "data-name": "Rectangle 31602",
    width: 5.31,
    height: 2.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31603",
    "data-name": "Rectangle 31603",
    width: 2.27,
    height: 5.375,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31604",
    "data-name": "Rectangle 31604",
    width: 5.49,
    height: 3.691,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31605",
    "data-name": "Rectangle 31605",
    width: 4.86,
    height: 3.632,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31606",
    "data-name": "Rectangle 31606",
    width: 5.371,
    height: 2.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31607",
    "data-name": "Rectangle 31607",
    width: 5.521,
    height: 1.663,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31609",
    "data-name": "Rectangle 31609",
    width: 27.227,
    height: 25.134,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31610",
    "data-name": "Rectangle 31610",
    width: 8.363,
    height: 12.782,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31611",
    "data-name": "Rectangle 31611",
    width: 6.559,
    height: 12.336,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31612",
    "data-name": "Rectangle 31612",
    width: 25.607,
    height: 19.041,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31613",
    "data-name": "Rectangle 31613",
    width: 23.208,
    height: 17.258,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31614",
    "data-name": "Rectangle 31614",
    width: 37.385,
    height: 54.863,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31615",
    "data-name": "Rectangle 31615",
    width: 12.66,
    height: 48.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31616",
    "data-name": "Rectangle 31616",
    width: 25.514,
    height: 13.701,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31617",
    "data-name": "Rectangle 31617",
    width: 41.825,
    height: 20.414,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31618",
    "data-name": "Rectangle 31618",
    width: 14.477,
    height: 13.694,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31619",
    "data-name": "Rectangle 31619",
    width: 16.958,
    height: 26.57,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31620",
    "data-name": "Rectangle 31620",
    width: 25.016,
    height: 38.136,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31621",
    "data-name": "Rectangle 31621",
    width: 23.544,
    height: 28.51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31622",
    "data-name": "Rectangle 31622",
    width: 41.492,
    height: 47.437,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31623",
    "data-name": "Rectangle 31623",
    width: 63.207,
    height: 56.341,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31624",
    "data-name": "Rectangle 31624",
    width: 14.216,
    height: 16.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31625",
    "data-name": "Rectangle 31625",
    width: 1.911,
    height: 5.524,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31626",
    "data-name": "Rectangle 31626",
    width: 6.134,
    height: 1.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31627",
    "data-name": "Rectangle 31627",
    width: 5.557,
    height: 1.338,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31628",
    "data-name": "Rectangle 31628",
    width: 4.067,
    height: 4.436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31629",
    "data-name": "Rectangle 31629",
    width: 4.812,
    height: 3.941,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31630",
    "data-name": "Rectangle 31630",
    width: 1.326,
    height: 5.539,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31631",
    "data-name": "Rectangle 31631",
    width: 6.098,
    height: 1.74,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31632",
    "data-name": "Rectangle 31632",
    width: 5.484,
    height: 1.933,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31633",
    "data-name": "Rectangle 31633",
    width: 4.488,
    height: 3.99,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31634",
    "data-name": "Rectangle 31634",
    width: 5.101,
    height: 3.454,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31635",
    "data-name": "Rectangle 31635",
    width: 1.683,
    height: 5.458,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31636",
    "data-name": "Rectangle 31636",
    width: 5.76,
    height: 3.134,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31637",
    "data-name": "Rectangle 31637",
    width: 5.127,
    height: 3.151,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31638",
    "data-name": "Rectangle 31638",
    width: 5.176,
    height: 2.836,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31639",
    "data-name": "Rectangle 31639",
    width: 5.472,
    height: 2.244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31640",
    "data-name": "Rectangle 31640",
    width: 19.201,
    height: 31.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31642",
    "data-name": "Rectangle 31642",
    width: 28.324,
    height: 24.361,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31643",
    "data-name": "Rectangle 31643",
    width: 9.07,
    height: 12.232,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31644",
    "data-name": "Rectangle 31644",
    width: 7.508,
    height: 11.877,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13234",
    "data-name": "Group 13234",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39107",
    "data-name": "Path 39107",
    d: "M344.392,778.908,470.915,836.6H754.991L573.6,778.908Z",
    transform: "translate(-169.319 -382.947)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31589",
    "data-name": "Rectangle 31589",
    width: 26.81,
    height: 453.65,
    transform: "translate(281.235 0.002)",
    fill: "#fd9d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39108",
    "data-name": "Path 39108",
    d: "M436.549,0,315.9,57.853V395.8l8.721,4.183,103.2,49.487,8.722,4.183Z",
    transform: "translate(-155.313 0)",
    fill: "#e25e16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39109",
    "data-name": "Path 39109",
    d: "M436.262,64.516V481.189L333.06,431.7v-322.6Z",
    transform: "translate(-163.748 -31.719)",
    fill: "#c2481a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39110",
    "data-name": "Path 39110",
    d: "M435.9,92.9V480.715l-81.134-39.1V127.226Z",
    transform: "translate(-174.419 -45.672)",
    fill: "#aa3b1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39111",
    "data-name": "Path 39111",
    d: "M484.916,485.369l-23.635-3.616V427.781l23.635-3.616Z",
    transform: "translate(-226.787 -208.539)",
    fill: "#6b2712"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13233",
    "data-name": "Group 13233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13232",
    "data-name": "Group 13232",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39112",
    "data-name": "Path 39112",
    d: "M484.71,457.439a5.034,5.034,0,0,0-6.146-5.165,6.476,6.476,0,0,0-4.944,6.239,5.231,5.231,0,0,0,2.834,4.781v9.838l4.411.93V463.327a6.478,6.478,0,0,0,3.845-5.888",
    transform: "translate(-232.853 -222.3)",
    fill: "#3e1a0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39113",
    "data-name": "Path 39113",
    d: "M486.092,457.44a5.029,5.029,0,0,0-5.777-5.229,6.864,6.864,0,0,0-3.885,6.09,5.472,5.472,0,0,0,2.965,5v10.158l2.852.6V463.328a6.478,6.478,0,0,0,3.845-5.888",
    transform: "translate(-234.235 -222.301)",
    fill: "#29140c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39114",
    "data-name": "Path 39114",
    d: "M198.239,191.759l-11.848-15.186,9.547-9,12.432,29.808Z",
    transform: "translate(-91.638 -82.388)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39115",
    "data-name": "Path 39115",
    d: "M177.328,175.783a10.836,10.836,0,1,1-10.837-10.836,10.837,10.837,0,0,1,10.837,10.836",
    transform: "translate(-76.528 -81.095)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39116",
    "data-name": "Path 39116",
    d: "M218.351,161.124a10.836,10.836,0,1,1-10.836-10.836,10.836,10.836,0,0,1,10.836,10.836",
    transform: "translate(-96.696 -73.888)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39117",
    "data-name": "Path 39117",
    d: "M191.978,143.769a13.451,13.451,0,1,1-13.451-13.451,13.451,13.451,0,0,1,13.451,13.451",
    transform: "translate(-81.158 -64.07)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39118",
    "data-name": "Path 39118",
    d: "M64.485,361.366,45.3,363.047,42.94,350.141l31.775,5.783Z",
    transform: "translate(-21.111 -172.145)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39119",
    "data-name": "Path 39119",
    d: "M38.7,364.4a10.836,10.836,0,1,1-14.987,3.2A10.836,10.836,0,0,1,38.7,364.4",
    transform: "translate(-10.798 -178.296)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39120",
    "data-name": "Path 39120",
    d: "M48.711,322a10.836,10.836,0,1,1-14.987,3.2A10.835,10.835,0,0,1,48.711,322",
    transform: "translate(-15.722 -157.451)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39121",
    "data-name": "Path 39121",
    d: "M20.77,331.412a13.451,13.451,0,1,1-18.6,3.97,13.451,13.451,0,0,1,18.6-3.97",
    transform: "translate(0 -161.872)",
    fill: "#201e21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39122",
    "data-name": "Path 39122",
    d: "M66.027,217.364v4.8a4.675,4.675,0,0,1-4.675,4.675H57.309",
    transform: "translate(-28.176 -106.866)",
    fill: "none",
    stroke: "#201e21",
    strokeWidth: 2.708
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39123",
    "data-name": "Path 39123",
    d: "M82.181,217.364v4.8a4.675,4.675,0,0,0,4.675,4.675H90.9",
    transform: "translate(-40.404 -106.866)",
    fill: "none",
    stroke: "#201e21",
    strokeWidth: 2.708
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39124",
    "data-name": "Path 39124",
    d: "M66.027,252.985v-4.8a4.675,4.675,0,0,0-4.675-4.675H57.309",
    transform: "translate(-28.176 -119.722)",
    fill: "none",
    stroke: "#201e21",
    strokeWidth: 2.708
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39125",
    "data-name": "Path 39125",
    d: "M82.181,252.985v-4.8a4.675,4.675,0,0,1,4.675-4.675H90.9",
    transform: "translate(-40.404 -119.722)",
    fill: "none",
    stroke: "#201e21",
    strokeWidth: 2.708
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39126",
    "data-name": "Path 39126",
    d: "M473.249,506.129a5.324,5.324,0,1,1-5.324-5.324,5.324,5.324,0,0,1,5.324,5.324",
    transform: "translate(-227.435 -246.219)",
    fill: "#1e100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39127",
    "data-name": "Path 39127",
    d: "M464.211,510.426l-10.127,1.063V498.716l10.127,1.062Z",
    transform: "translate(-223.248 -245.191)",
    fill: "#1e100b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39128",
    "data-name": "Path 39128",
    d: "M453.68,505.1a6.386,6.386,0,1,1-6.386-6.386,6.387,6.387,0,0,1,6.386,6.386",
    transform: "translate(-216.77 -245.191)",
    fill: "#29140c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39129",
    "data-name": "Path 39129",
    d: "M278.8,560.107a4.488,4.488,0,0,0-1.687-1.754l-7.05-4.06-5.815,5.69a4.492,4.492,0,0,0-1.2,2.119s-3.04,20.779-2.971,27.771c.05,5.1,2.564,20.248,2.564,20.248s7.475,5.389,15.05,4.429,13.47-8.041,13.47-8.041-1.342-15.3-2.564-20.248c-1.677-6.789-9.8-26.154-9.8-26.154",
    transform: "translate(-127.868 -272.516)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39130",
    "data-name": "Path 39130",
    d: "M282.926,559.585a4.489,4.489,0,0,0-1.687-1.754l-7.05-4.06-5.815,5.69a4.491,4.491,0,0,0-1.2,2.119s-3.04,20.779-2.971,27.771c.05,5.1,2.564,20.248,2.564,20.248s7.475,5.389,15.05,4.429,13.471-8.041,13.471-8.041-1.342-15.3-2.564-20.248c-1.677-6.789-9.8-26.154-9.8-26.154",
    transform: "translate(-129.895 -272.259)",
    fill: "#4f5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39131",
    "data-name": "Path 39131",
    d: "M280.606,553.771l-2.1.265-1.253,1.225,1.513.305Z",
    transform: "translate(-136.312 -272.259)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39132",
    "data-name": "Path 39132",
    d: "M303.555,638.26a19.137,19.137,0,1,1-22.1-15.617,19.137,19.137,0,0,1,22.1,15.617",
    transform: "translate(-130.559 -305.982)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39133",
    "data-name": "Path 39133",
    d: "M303.538,639.279a18.241,18.241,0,1,1-21.069-14.886,18.241,18.241,0,0,1,21.069,14.886",
    transform: "translate(-131.425 -306.849)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39134",
    "data-name": "Path 39134",
    d: "M303.5,641.836a15.991,15.991,0,1,1-18.47-13.05,15.991,15.991,0,0,1,18.47,13.05",
    transform: "translate(-133.601 -309.025)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39135",
    "data-name": "Path 39135",
    d: "M286.641,557.441a4.493,4.493,0,0,0-1.763-1.678l-7.223-3.744-5.557,5.942a4.491,4.491,0,0,0-1.1,2.17s-2.116,20.893-1.738,27.876c.276,5.092,3.459,20.114,3.459,20.114s7.707,5.052,15.231,3.758,13.1-8.631,13.1-8.631-2.018-15.222-3.459-20.114c-1.976-6.708-10.95-25.694-10.95-25.694",
    transform: "translate(-132.357 -271.398)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39136",
    "data-name": "Path 39136",
    d: "M290.737,556.737a4.493,4.493,0,0,0-1.763-1.677l-7.223-3.744-5.557,5.942a4.491,4.491,0,0,0-1.1,2.17s-2.116,20.893-1.738,27.876c.276,5.092,3.459,20.114,3.459,20.114s7.707,5.052,15.231,3.758,13.1-8.631,13.1-8.631-2.018-15.222-3.459-20.114c-1.976-6.708-10.95-25.694-10.95-25.694",
    transform: "translate(-134.371 -271.052)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39137",
    "data-name": "Path 39137",
    d: "M286.744,551.316l-2.082.358-1.2,1.28,1.525.238Z",
    transform: "translate(-139.364 -271.052)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39138",
    "data-name": "Path 39138",
    d: "M219.952,806.795,167.5,776.871l10.322-11.881,6.783-7.806,8.145-9.376,41.557,23.268-3.007,7.483-2.091,5.2Z",
    transform: "translate(-82.352 -367.656)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39139",
    "data-name": "Path 39139",
    d: "M283.369,855.881l-9.831.089L262.31,872.986l-6.112-3.423s10.352-17.36,10.456-17.545,6.46-3.631,6.46-3.631l5.645,2.869L280.6,853.1Z",
    transform: "translate(-125.959 -417.106)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39140",
    "data-name": "Path 39140",
    d: "M280.6,853.1l-6.752-1.846-7.819,7.126-7.113,12.7-2.714-1.519s10.352-17.36,10.456-17.545,6.46-3.631,6.46-3.631l5.644,2.869Z",
    transform: "translate(-125.959 -417.106)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39141",
    "data-name": "Path 39141",
    d: "M154.956,792.373l-3.352,4.618,45.711,25.387,24.193-3.286-4.131-4.308-26.306-2.761Z",
    transform: "translate(-74.536 -389.567)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13075",
    "data-name": "Group 13075",
    transform: "translate(95.473 389.527)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13074",
    "data-name": "Group 13074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13073",
    "data-name": "Group 13073",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39142",
    "data-name": "Path 39142",
    d: "M239.195,792.826l-20.373-1.4-31.014-17.365,6.783-7.806,46.7,21.375Z",
    transform: "translate(-187.808 -766.251)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39143",
    "data-name": "Path 39143",
    d: "M240.748,740.991l-14.768-1.072-1.434-.105-6.593-.476-.076.989-.033.442L205,733.577l.756-1.351-19.951-11.171,42.122-53.5.011.006c3.853-6.116,13.951-7.076,22.886-2.074a25.828,25.828,0,0,1,5.252,3.867c.345.327.677.664.993,1.008,4.551,4.9,6.273,11.006,3.948,15.721l.009.005-20.273,54.886a.118.118,0,0,1-.007.016",
    transform: "translate(-91.351 -325.606)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39144",
    "data-name": "Path 39144",
    d: "M270.314,828.708l-16.524-9.252,19.4,1.461Z",
    transform: "translate(-124.775 -402.882)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39145",
    "data-name": "Path 39145",
    d: "M199.024,812.138l-45.662-25.567,2.184-2.65,11.76-2.847,21.205,11.873.54-.964,12.842,7.191-.091,1.215,2.613.2,16.524,9.252Z",
    transform: "translate(-75.399 -384.012)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39146",
    "data-name": "Path 39146",
    d: "M217.55,826.433l-7.458-2.029-8.126,7.345-8.308,14.577L128.074,809.6l11.059-13.427,46.583,26.083,25.167-2.589Z",
    transform: "translate(-62.967 -391.437)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39147",
    "data-name": "Path 39147",
    d: "M290.239,893.068l-29.28-16.394,7.405-13.226,8.46-7.784,8.45,2.442,3.365,3.413Z",
    transform: "translate(-128.3 -420.683)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13078",
    "data-name": "Group 13078",
    transform: "translate(134.629 344.756)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13077",
    "data-name": "Group 13077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13076",
    "data-name": "Group 13076",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39148",
    "data-name": "Path 39148",
    d: "M279.6,748.809l-14.768-1.072,31.091-69.556c4.551,4.9,6.273,11.006,3.948,15.721l.009.005-20.273,54.886a.117.117,0,0,1-.007.016",
    transform: "translate(-264.833 -678.181)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39149",
    "data-name": "Path 39149",
    d: "M217.954,739.337l-.076.989-1.16-.19L205,733.577l.756-1.351-19.951-11.171,42.122-53.5.011.006c3.853-6.116,13.951-7.076,22.886-2.074a25.828,25.828,0,0,1,5.252,3.867l-31.531,70.459Z",
    transform: "translate(-91.351 -325.606)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39150",
    "data-name": "Path 39150",
    d: "M234.255,804.737a8.881,8.881,0,1,1-3.411-12.089,8.882,8.882,0,0,1,3.411,12.089",
    transform: "translate(-106.993 -389.145)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39151",
    "data-name": "Path 39151",
    d: "M234.414,805.542a7.2,7.2,0,1,1-2.765-9.8,7.2,7.2,0,0,1,2.765,9.8",
    transform: "translate(-108.618 -390.77)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39152",
    "data-name": "Path 39152",
    d: "M234.552,806.241a5.743,5.743,0,1,1-2.205-7.816,5.742,5.742,0,0,1,2.205,7.816",
    transform: "translate(-110.029 -392.182)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39153",
    "data-name": "Path 39153",
    d: "M155.536,795.015l44.393,24.751,21.055-2.46-.9-.934-19.995,2.1-43.787-24.517Z",
    transform: "translate(-76.468 -390.344)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39154",
    "data-name": "Path 39154",
    d: "M157.677,824.72l-1.6-.894,2.222-8.565,6.141-6.37,1.6.893-6.141,6.371Z",
    transform: "translate(-76.737 -397.687)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39155",
    "data-name": "Path 39155",
    d: "M164.925,809.16l-.481-.27-6.141,6.37-2.222,8.565.481.27,2.222-8.565Z",
    transform: "translate(-76.736 -397.687)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39156",
    "data-name": "Path 39156",
    d: "M221.852,860.652l1.6.894,6.141-6.371,2.222-8.565-1.6-.894-2.221,8.565Z",
    transform: "translate(-109.072 -415.792)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39157",
    "data-name": "Path 39157",
    d: "M232.406,846.943l.481.27-2.221,8.565-6.141,6.371-.482-.269,6.141-6.371Z",
    transform: "translate(-110.15 -416.396)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39158",
    "data-name": "Path 39158",
    d: "M226.445,417.639a4.642,4.642,0,1,1-5.241,3.952,4.642,4.642,0,0,1,5.241-3.952",
    transform: "translate(-108.732 -205.308)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39159",
    "data-name": "Path 39159",
    d: "M227.917,426.333a1.744,1.744,0,1,0-.857-2.314,1.745,1.745,0,0,0,.857,2.314",
    transform: "translate(-111.554 -207.968)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39160",
    "data-name": "Path 39160",
    d: "M227.728,427.133a1.618,1.618,0,1,0-.8-2.145,1.618,1.618,0,0,0,.8,2.145",
    transform: "translate(-111.498 -208.48)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39161",
    "data-name": "Path 39161",
    d: "M227.906,427.717a1.3,1.3,0,1,0-.64-1.726,1.3,1.3,0,0,0,.64,1.726",
    transform: "translate(-111.676 -209.064)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39162",
    "data-name": "Path 39162",
    d: "M273.5,491.7c-1.256,5.244.723,10.213,4.421,11.1s7.715-2.647,8.971-7.891-.723-10.213-4.422-11.1-7.714,2.647-8.97,7.891",
    transform: "translate(-134.277 -237.794)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39163",
    "data-name": "Path 39163",
    d: "M204.686,364.937s-1.875,3.626-11.015,9.094c-9.114,5.453-13.185,5.387-13.185,5.387l-5.48-9.158,24.2-14.481Z",
    transform: "translate(-86.041 -174.917)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39164",
    "data-name": "Path 39164",
    d: "M258.835,461.359l8.405,16.379.6,1.178,4.961,9.667.6,1.178.164.318s-1.7,3.078-9.688,7.57c-7.969,4.479-11.471,4.328-11.471,4.328L236.95,479.331Z",
    transform: "translate(-116.495 -226.825)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39165",
    "data-name": "Path 39165",
    d: "M198.221,354.012s-.711,5.094-10.161,10.607c-9.34,5.449-14.2,3.6-14.2,3.6l-4.81-8.243,24.359-14.213Z",
    transform: "translate(-83.114 -169.995)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39166",
    "data-name": "Path 39166",
    d: "M197.237,354.322a41.5,41.5,0,0,1-23.071,13.461,2.386,2.386,0,0,1-2.972-1.841,2.507,2.507,0,0,1,2.05-2.693,36.87,36.87,0,0,0,20.5-11.96,2.506,2.506,0,0,1,3.353-.46,2.387,2.387,0,0,1,.14,3.493",
    transform: "translate(-84.158 -172.262)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39167",
    "data-name": "Path 39167",
    d: "M187.747,363.168a39.4,39.4,0,0,1-12.032,4.588.576.576,0,0,1-.568-.122.461.461,0,0,1,.257-.376.657.657,0,0,1,.2-.075,38.9,38.9,0,0,0,21.619-12.615.661.661,0,0,1,.161-.133.452.452,0,0,1,.463-.028.612.612,0,0,1-.181.544,39.4,39.4,0,0,1-9.916,8.218",
    transform: "translate(-86.11 -174.216)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39168",
    "data-name": "Path 39168",
    d: "M186.831,361.6a39.4,39.4,0,0,1-12.032,4.588.576.576,0,0,1-.568-.123.461.461,0,0,1,.257-.376.658.658,0,0,1,.2-.075A38.9,38.9,0,0,0,196.3,353a.66.66,0,0,1,.161-.133.452.452,0,0,1,.463-.028.612.612,0,0,1-.181.544,39.4,39.4,0,0,1-9.916,8.218",
    transform: "translate(-85.659 -173.444)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39169",
    "data-name": "Path 39169",
    d: "M202.752,362.579a49.911,49.911,0,0,1-25.36,14.8c-1.594.372-3-.467-3.113-1.759a2.865,2.865,0,0,1,2.319-2.849,44.346,44.346,0,0,0,22.533-13.147,2.863,2.863,0,0,1,3.621-.617c1.069.735,1.107,2.37,0,3.575",
    transform: "translate(-85.679 -176.304)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39170",
    "data-name": "Path 39170",
    d: "M192.4,372.189a47.624,47.624,0,0,1-13.232,5.269l-.01,0a.292.292,0,0,1-.213-.532l.021-.012a1.188,1.188,0,0,1,.325-.13,46.369,46.369,0,0,0,23.562-13.749,1.177,1.177,0,0,1,.272-.218l.021-.012a.292.292,0,0,1,.358.447l-.007.007a47.586,47.586,0,0,1-11.1,8.927",
    transform: "translate(-87.909 -178.354)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39171",
    "data-name": "Path 39171",
    d: "M190.882,369.6a47.627,47.627,0,0,1-13.232,5.269l-.01,0a.292.292,0,0,1-.213-.532l.021-.012a1.173,1.173,0,0,1,.325-.13,46.363,46.363,0,0,0,23.562-13.748,1.178,1.178,0,0,1,.272-.218l.021-.012a.292.292,0,0,1,.358.447l-.007.007a47.6,47.6,0,0,1-11.1,8.927",
    transform: "translate(-87.165 -177.08)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39172",
    "data-name": "Path 39172",
    d: "M263.343,470.607a50.6,50.6,0,0,0-23.09,16.811,1.208,1.208,0,0,1-1.77.154l-4.516-4.105a1.207,1.207,0,0,1-.156-1.622,56.238,56.238,0,0,1,26.206-19.079,1.206,1.206,0,0,1,1.5.646l2.52,5.559a1.209,1.209,0,0,1-.69,1.637",
    transform: "translate(-114.833 -227.483)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13081",
    "data-name": "Group 13081",
    transform: "translate(118.736 235.215)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13080",
    "data-name": "Group 13080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13079",
    "data-name": "Group 13079",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39173",
    "data-name": "Path 39173",
    d: "M233.991,483.486a1.2,1.2,0,0,1,.137-1.21A56.237,56.237,0,0,1,260.333,463.2a1.2,1.2,0,0,1,1.194.241l-.013-.028a1.207,1.207,0,0,0-1.5-.646,56.242,56.242,0,0,0-26.206,19.079,1.207,1.207,0,0,0,.155,1.622l.023.021",
    transform: "translate(-233.569 -462.698)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39174",
    "data-name": "Path 39174",
    d: "M464.784,459.394s3.315,6.545,1.316,10.186c-1.6,2.916-3.1,5.631-3.289,5.949a4.515,4.515,0,0,1-1.084.844c-1.927,1.243-7.615.551-7.886.159-.351-.508-.9-3.139.742-3.633,1.3-.39,2.86.8,3.917.129a2.732,2.732,0,0,0,.551-.409c.144-.185,1.494-2.559,2.99-5.215,2-3.549-1.692-7.131-1.692-7.131Z",
    transform: "translate(-222.943 -225.859)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39175",
    "data-name": "Path 39175",
    d: "M464.942,461.386c.412,2.052,2.55,6.368,1.239,8.753-1.591,2.9-3,5.456-3.249,5.882a6.54,6.54,0,0,1-.963.7c-1.548.981-5.626.4-6.65.143a3.081,3.081,0,0,1-.048-1.768.571.571,0,0,1,.394-.388c.883-.265,2.483.332,3.118.2a3.7,3.7,0,0,0,1.111-.238,2.57,2.57,0,0,0,.668-.532c.167-.214,1.5-2.55,3.021-5.252,1.378-2.443-1.02-4.985-1.394-6.947Z",
    transform: "translate(-223.777 -226.838)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39176",
    "data-name": "Path 39176",
    d: "M453.41,484.472a1.288,1.288,0,0,0-.629-.234,23.776,23.776,0,0,0-4.346-.125c-2.262.468-2.959,4.015-1.148,4.744a45.991,45.991,0,0,0,4.82.841,4.247,4.247,0,0,0,.905.068,26.622,26.622,0,0,0,.4-5.3",
    transform: "translate(-219.4 -237.99)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13084",
    "data-name": "Group 13084",
    transform: "translate(232.707 246.248)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13083",
    "data-name": "Group 13083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13082",
    "data-name": "Group 13082",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39177",
    "data-name": "Path 39177",
    d: "M459.068,484.637a1.288,1.288,0,0,0-.629-.234,14.971,14.971,0,0,1-.674,5.461,4.242,4.242,0,0,0,.905.068,26.62,26.62,0,0,0,.4-5.3",
    transform: "translate(-457.765 -484.403)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39178",
    "data-name": "Path 39178",
    d: "M463.781,480.922c.416-.744,1.459-2.562,2.064-3.535a4.461,4.461,0,0,1,.432-.635c.212-.145,4.658,2.774,4.658,2.774s-.145.272-.374.7c-.62,1.146-1.854,3.394-2.485,4.309a1.385,1.385,0,0,1-.342.4s-4.24-3.455-4.128-3.691c.016-.034.079-.147.175-.319",
    transform: "translate(-227.929 -234.391)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39179",
    "data-name": "Path 39179",
    d: "M467.617,468.918a1.693,1.693,0,0,1-.386-.616,30.572,30.572,0,0,1-1.539-5.414c-.077-.44-.1-.719-.036-.727,1.42-.182,4.952-.748,5.647-.978.138-.047.279.172.418.558a29.912,29.912,0,0,1,.958,5.288,2.951,2.951,0,0,1,.031.655,21.917,21.917,0,0,1-5.093,1.234",
    transform: "translate(-228.92 -226.735)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13087",
    "data-name": "Group 13087",
    transform: "translate(236.7 234.441)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13086",
    "data-name": "Group 13086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13085",
    "data-name": "Group 13085",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39180",
    "data-name": "Path 39180",
    d: "M471.721,461.741a24.838,24.838,0,0,1-6.029,1.147c-.077-.44-.1-.719-.036-.727,1.42-.182,4.952-.748,5.647-.978.138-.047.279.171.418.558",
    transform: "translate(-465.62 -461.176)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13090",
    "data-name": "Group 13090",
    transform: "translate(238.311 240.293)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13089",
    "data-name": "Group 13089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13088",
    "data-name": "Group 13088",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39181",
    "data-name": "Path 39181",
    d: "M469.176,474.578a1.693,1.693,0,0,1-.386-.616,14.245,14.245,0,0,0,5.448-1.274,2.949,2.949,0,0,1,.031.655,21.916,21.916,0,0,1-5.093,1.234",
    transform: "translate(-468.789 -472.688)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13093",
    "data-name": "Group 13093",
    transform: "translate(235.675 246.532)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13092",
    "data-name": "Group 13092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13091",
    "data-name": "Group 13091",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39182",
    "data-name": "Path 39182",
    d: "M463.781,484.96a12.79,12.79,0,0,1,4.295,3.61,1.386,1.386,0,0,1-.342.4s-4.24-3.455-4.128-3.691c.016-.034.079-.147.175-.319",
    transform: "translate(-463.604 -484.96)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13096",
    "data-name": "Group 13096",
    transform: "translate(237.917 242.357)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13095",
    "data-name": "Group 13095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13094",
    "data-name": "Group 13094",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39183",
    "data-name": "Path 39183",
    d: "M468.013,477.388a4.51,4.51,0,0,1,.432-.635c.212-.145,4.658,2.774,4.658,2.774s-.145.272-.374.7a29.657,29.657,0,0,0-4.717-2.835",
    transform: "translate(-468.013 -476.748)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39184",
    "data-name": "Path 39184",
    d: "M466.185,461.6s4.074,6.1,2.525,9.956c-1.241,3.087-2.4,5.96-2.554,6.3a4.534,4.534,0,0,1-.976.967c-1.765,1.465-7.495,1.458-7.81,1.1-.409-.463-1.27-3.009.3-3.7,1.242-.543,2.936.449,3.9-.341a2.7,2.7,0,0,0,.5-.471c.121-.2,1.177-2.719,2.346-5.535,1.561-3.763-2.533-6.878-2.533-6.878Z",
    transform: "translate(-224.566 -226.944)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39185",
    "data-name": "Path 39185",
    d: "M466.468,463.738c.654,1.989,3.293,6.017,2.277,8.542-1.233,3.065-2.328,5.775-2.523,6.228a6.587,6.587,0,0,1-.873.806c-1.42,1.159-5.538,1.073-6.586.937a3.088,3.088,0,0,1-.259-1.749.573.573,0,0,1,.345-.432c.845-.369,2.506.033,3.119-.178a3.7,3.7,0,0,0,1.075-.369,2.585,2.585,0,0,0,.6-.608c.14-.232,1.182-2.711,2.372-5.576,1.075-2.59-1.609-4.827-2.215-6.73Z",
    transform: "translate(-225.399 -227.995)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39186",
    "data-name": "Path 39186",
    d: "M456.457,488.566a1.29,1.29,0,0,0-.653-.158,23.815,23.815,0,0,0-4.329.4c-2.19.735-2.458,4.34-.572,4.848a45.874,45.874,0,0,0,4.886.259,4.266,4.266,0,0,0,.907-.04,26.583,26.583,0,0,0-.238-5.3",
    transform: "translate(-221.066 -240.118)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13099",
    "data-name": "Group 13099",
    transform: "translate(234.723 248.291)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13098",
    "data-name": "Group 13098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13097",
    "data-name": "Group 13097",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39187",
    "data-name": "Path 39187",
    d: "M462.4,488.578a1.291,1.291,0,0,0-.653-.158,14.967,14.967,0,0,1-.016,5.5,4.265,4.265,0,0,0,.907-.04,26.584,26.584,0,0,0-.238-5.3",
    transform: "translate(-461.731 -488.421)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39188",
    "data-name": "Path 39188",
    d: "M466.525,484.092c.324-.789,1.142-2.718,1.626-3.756a4.437,4.437,0,0,1,.353-.682c.194-.17,4.956,2.2,4.956,2.2s-.111.288-.288.736c-.478,1.212-1.435,3.591-1.953,4.576a1.387,1.387,0,0,1-.291.438s-4.623-2.923-4.54-3.172c.012-.035.06-.156.136-.337",
    transform: "translate(-229.298 -235.815)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39189",
    "data-name": "Path 39189",
    d: "M468.5,471.365a1.7,1.7,0,0,1-.457-.565,30.671,30.671,0,0,1-2.176-5.192c-.129-.428-.182-.7-.122-.718,1.389-.351,4.827-1.334,5.489-1.646.132-.064.3.137.482.5a29.909,29.909,0,0,1,1.584,5.135,2.951,2.951,0,0,1,.109.647,21.945,21.945,0,0,1-4.909,1.834",
    transform: "translate(-228.97 -227.746)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13102",
    "data-name": "Group 13102",
    transform: "translate(236.752 235.487)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13101",
    "data-name": "Group 13101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13100",
    "data-name": "Group 13100",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39190",
    "data-name": "Path 39190",
    d: "M471.717,463.748a24.822,24.822,0,0,1-5.849,1.86c-.129-.428-.182-.7-.122-.718,1.389-.351,4.827-1.334,5.489-1.646.132-.063.3.137.482.5",
    transform: "translate(-465.722 -463.233)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13105",
    "data-name": "Group 13105",
    transform: "translate(239.075 241.137)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13104",
    "data-name": "Group 13104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13103",
    "data-name": "Group 13103",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39191",
    "data-name": "Path 39191",
    d: "M470.748,476.83a1.7,1.7,0,0,1-.457-.565,14.252,14.252,0,0,0,5.256-1.916,2.946,2.946,0,0,1,.109.647,21.943,21.943,0,0,1-4.909,1.834",
    transform: "translate(-470.291 -474.349)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13108",
    "data-name": "Group 13108",
    transform: "translate(237.09 248.276)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13107",
    "data-name": "Group 13107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13106",
    "data-name": "Group 13106",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39192",
    "data-name": "Path 39192",
    d: "M466.525,488.392a12.793,12.793,0,0,1,4.7,3.07,1.387,1.387,0,0,1-.291.438s-4.623-2.923-4.54-3.172c.012-.035.06-.156.136-.337",
    transform: "translate(-466.388 -488.392)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13111",
    "data-name": "Group 13111",
    transform: "translate(238.853 243.83)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13110",
    "data-name": "Group 13110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13109",
    "data-name": "Group 13109",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39193",
    "data-name": "Path 39193",
    d: "M469.856,480.336a4.439,4.439,0,0,1,.353-.682c.194-.17,4.956,2.2,4.956,2.2s-.111.288-.288.736a29.706,29.706,0,0,0-5.022-2.25",
    transform: "translate(-469.856 -479.645)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39194",
    "data-name": "Path 39194",
    d: "M472.161,459.628s5.5,4.851,5,8.973c-.407,3.3-.79,6.377-.85,6.744a4.526,4.526,0,0,1-.694,1.186c-1.329,1.869-6.869,3.333-7.265,3.07-.514-.343-2-2.582-.658-3.65,1.061-.843,2.953-.319,3.686-1.332a2.673,2.673,0,0,0,.359-.584c.066-.224.44-2.93.845-5.952.542-4.037-4.214-6-4.214-6Z",
    transform: "translate(-229.668 -225.974)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39195",
    "data-name": "Path 39195",
    d: "M472.741,461.971c1.143,1.754,4.728,4.969,4.395,7.671-.4,3.279-.766,6.18-.839,6.667a6.536,6.536,0,0,1-.637,1c-1.074,1.485-5.076,2.459-6.124,2.6a3.09,3.09,0,0,1-.7-1.624.573.573,0,0,1,.222-.506c.722-.574,2.43-.612,2.968-.973a3.707,3.707,0,0,0,.945-.632,2.589,2.589,0,0,0,.423-.742c.076-.26.446-2.924.86-6,.374-2.779-2.795-4.252-3.869-5.936Z",
    transform: "translate(-230.502 -227.126)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39196",
    "data-name": "Path 39196",
    d: "M466.429,488.957a1.292,1.292,0,0,0-.671.015,23.767,23.767,0,0,0-4.083,1.495c-1.928,1.273-1.261,4.826.692,4.832a45.778,45.778,0,0,0,4.788-1,4.26,4.26,0,0,0,.866-.272,26.617,26.617,0,0,0-1.593-5.066",
    transform: "translate(-226.414 -240.375)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13114",
    "data-name": "Group 13114",
    transform: "translate(239.344 248.545)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13113",
    "data-name": "Group 13113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13112",
    "data-name": "Group 13112",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39197",
    "data-name": "Path 39197",
    d: "M471.493,488.957a1.291,1.291,0,0,0-.671.015,14.964,14.964,0,0,1,1.4,5.322,4.262,4.262,0,0,0,.866-.272,26.617,26.617,0,0,0-1.593-5.066",
    transform: "translate(-470.822 -488.92)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39198",
    "data-name": "Path 39198",
    d: "M475.5,483.073c.111-.846.406-2.92.607-4.048a4.484,4.484,0,0,1,.166-.75c.143-.214,5.355.851,5.355.851s-.034.307-.089.785c-.151,1.294-.465,3.84-.712,4.924a1.392,1.392,0,0,1-.169.5s-5.219-1.637-5.2-1.9c0-.038.019-.166.045-.361",
    transform: "translate(-233.756 -235.128)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39199",
    "data-name": "Path 39199",
    d: "M473.377,469.423a1.7,1.7,0,0,1-.587-.429,30.609,30.609,0,0,1-3.436-4.459c-.235-.38-.357-.631-.3-.662,1.252-.7,4.323-2.53,4.882-3,.111-.095.323.056.6.363a29.9,29.9,0,0,1,2.849,4.556,3.009,3.009,0,0,1,.272.6,21.912,21.912,0,0,1-4.273,3.033",
    transform: "translate(-230.601 -226.572)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13117",
    "data-name": "Group 13117",
    transform: "translate(238.438 234.273)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13116",
    "data-name": "Group 13116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13115",
    "data-name": "Group 13115",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39200",
    "data-name": "Path 39200",
    d: "M474.528,461.237a24.816,24.816,0,0,1-5.175,3.3c-.234-.38-.357-.631-.3-.662,1.252-.7,4.323-2.529,4.883-3,.111-.1.323.055.595.363",
    transform: "translate(-469.039 -460.845)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13120",
    "data-name": "Group 13120",
    transform: "translate(242.19 239.221)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13119",
    "data-name": "Group 13119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13118",
    "data-name": "Group 13118",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39201",
    "data-name": "Path 39201",
    d: "M477.006,474.209a1.7,1.7,0,0,1-.587-.428,14.25,14.25,0,0,0,4.588-3.2,3.01,3.01,0,0,1,.272.6,21.913,21.913,0,0,1-4.273,3.033",
    transform: "translate(-476.419 -470.579)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13123",
    "data-name": "Group 13123",
    transform: "translate(241.701 247.945)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13122",
    "data-name": "Group 13122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13121",
    "data-name": "Group 13121",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39202",
    "data-name": "Path 39202",
    d: "M475.5,487.74a12.785,12.785,0,0,1,5.326,1.762,1.391,1.391,0,0,1-.169.5s-5.219-1.637-5.2-1.9c0-.038.019-.166.045-.361",
    transform: "translate(-475.457 -487.74)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13126",
    "data-name": "Group 13126",
    transform: "translate(242.352 243.119)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13125",
    "data-name": "Group 13125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13124",
    "data-name": "Group 13124",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39203",
    "data-name": "Path 39203",
    d: "M476.739,479.024a4.425,4.425,0,0,1,.166-.75c.143-.214,5.354.85,5.354.85s-.034.306-.089.785a29.7,29.7,0,0,0-5.431-.886",
    transform: "translate(-476.739 -478.247)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39204",
    "data-name": "Path 39204",
    d: "M443.91,465.8l-.365,2.607a5.317,5.317,0,0,1-3.535,4.29l-13.45,4.629a5.316,5.316,0,0,1-5.3-1.086l-3.7-3.348Z",
    transform: "translate(-205.295 -229.008)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39205",
    "data-name": "Path 39205",
    d: "M414.265,458.477s21.635-6.7,23.8-6.912,8.966,4.786,9.294,5.93-31.423,11.2-31.964,10.319-2.383-8.279-1.135-9.337",
    transform: "translate(-203.462 -222.007)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39206",
    "data-name": "Path 39206",
    d: "M280.064,453.692l17.784,4.1a1.065,1.065,0,0,0,.716-1.99L282.3,448.85Z",
    transform: "translate(-137.692 -220.675)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39207",
    "data-name": "Path 39207",
    d: "M281.139,452.509l17.792,4.138a1.085,1.085,0,0,0,.732-.085,1.065,1.065,0,0,0-.57-.76L282.83,448.85Z",
    transform: "translate(-138.221 -220.675)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39208",
    "data-name": "Path 39208",
    d: "M302.868,439.639c5.459,2.779,8.345,9.085,6.445,14.087s-7.866,6.8-13.326,4.026-8.345-9.085-6.445-14.086,7.866-6.8,13.326-4.027",
    transform: "translate(-142.065 -215.505)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39209",
    "data-name": "Path 39209",
    d: "M304.335,442.312c4.74,2.428,7.36,7.634,5.853,11.628s-6.571,5.263-11.311,2.835-7.36-7.634-5.853-11.628,6.572-5.263,11.311-2.835",
    transform: "translate(-143.854 -216.855)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39210",
    "data-name": "Path 39210",
    d: "M306.228,444.656c4.029,1.956,6.122,6.371,4.674,9.861s-5.887,4.732-9.916,2.776-6.122-6.371-4.674-9.861,5.887-4.732,9.916-2.776",
    transform: "translate(-145.455 -218.158)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31608",
    "data-name": "Rectangle 31608",
    width: 25.295,
    height: 12.409,
    transform: "matrix(0.207, -0.978, 0.978, 0.207, 176.573, 247.313)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39211",
    "data-name": "Path 39211",
    d: "M331.732,433.139a.817.817,0,0,1,.4,1.39,22.814,22.814,0,0,0-5.168,24.5.817.817,0,0,1-.925,1.109l-19.054-4.025a13.8,13.8,0,1,1,5.7-27Z",
    transform: "translate(-145.543 -210.825)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39212",
    "data-name": "Path 39212",
    d: "M363.516,440.458l5.773,1.22-5.228,24.749-5.769-1.219c-.024-.05-.044-.1-.062-.141a22.811,22.811,0,0,1,5.167-24.5,1.466,1.466,0,0,1,.118-.106",
    transform: "translate(-175.348 -216.549)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39213",
    "data-name": "Path 39213",
    d: "M367.334,439.349l24.33,6.131s4.505,1.855,2.036,13.541c-2.395,11.337-7.346,11.593-7.346,11.593l-24.718-4.264a2.91,2.91,0,0,1-1.624-1.648,22.812,22.812,0,0,1,5.167-24.5,3.159,3.159,0,0,1,2.154-.852",
    transform: "translate(-176.224 -215.995)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13129",
    "data-name": "Group 13129",
    transform: "translate(190.989 229.485)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13128",
    "data-name": "Group 13128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13127",
    "data-name": "Group 13127",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39214",
    "data-name": "Path 39214",
    d: "M400.151,451.428s4.505,1.855,2.037,13.541c-2.4,11.337-7.346,11.593-7.346,11.593a66.865,66.865,0,0,1-19.142-7.751s8.753,2.579,16.07,1.063,8.381-18.446,8.381-18.446",
    transform: "translate(-375.7 -451.428)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39215",
    "data-name": "Path 39215",
    d: "M315.562,440.108a8.143,8.143,0,1,1-11.1-3.06,8.143,8.143,0,0,1,11.1,3.06",
    transform: "translate(-147.659 -214.35)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39216",
    "data-name": "Path 39216",
    d: "M253.147,426.164c.793.91,1.36,2.466.916,5.344a9.061,9.061,0,0,1-6.437,7.437,11.837,11.837,0,0,1-1.233-1.366c-.128-.163-.245-.327-.355-.489a9.786,9.786,0,0,1-1.68-3.931c1.058-3.814,2.259-5.612,4.3-6.409a7.983,7.983,0,0,1,1.981-.465,19.877,19.877,0,0,1,2.51-.121",
    transform: "translate(-120.138 -209.521)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13132",
    "data-name": "Group 13132",
    transform: "translate(125.718 216.642)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13131",
    "data-name": "Group 13131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13130",
    "data-name": "Group 13130",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39217",
    "data-name": "Path 39217",
    d: "M254.6,426.164c.793.91,1.36,2.466.916,5.344a9.061,9.061,0,0,1-6.437,7.437,11.84,11.84,0,0,1-1.233-1.366c-.128-.163-.245-.327-.355-.489a10.421,10.421,0,0,1,.493-5.587,10.065,10.065,0,0,1,4.106-5.218,19.877,19.877,0,0,1,2.51-.121",
    transform: "translate(-247.304 -426.163)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39218",
    "data-name": "Path 39218",
    d: "M230.206,434.882l22.3,4.928.811-3.054-23.179-4.851Z",
    transform: "translate(-113.148 -212.345)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39219",
    "data-name": "Path 39219",
    d: "M230.03,426.726l23.375,4.232.643-3.094-24.083-4.086Z",
    transform: "translate(-113.061 -208.349)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39220",
    "data-name": "Path 39220",
    d: "M257.232,425.455c6.732.212,12.465,4.907,12.465,4.907l-4.115,12.867a22.478,22.478,0,0,1-12.73-1.977,13.61,13.61,0,0,1-4.16-3.249l0-.005a.5.5,0,0,1,.154-.765c1.823-.942,4.763-2.947,5.418-6.291.733-3.745-.97-4.568-2.746-4.819a.176.176,0,0,1-.024-.344c.161-.043.328-.08.5-.112h.006a24.555,24.555,0,0,1,5.239-.212",
    transform: "translate(-122.207 -209.156)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13135",
    "data-name": "Group 13135",
    transform: "translate(126.361 216.512)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13134",
    "data-name": "Group 13134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13133",
    "data-name": "Group 13133",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39221",
    "data-name": "Path 39221",
    d: "M251.987,425.908h.006c1.288.165,3.84,1.026,2.949,5.365a9.617,9.617,0,0,1-6.25,6.971l0-.005a.5.5,0,0,1,.154-.764c1.823-.943,4.764-2.948,5.418-6.291.733-3.745-.97-4.568-2.746-4.819a.175.175,0,0,1-.024-.343c.161-.043.328-.08.5-.112",
    transform: "translate(-248.568 -425.907)",
    fill: "#1d1c1c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39222",
    "data-name": "Path 39222",
    d: "M283.459,440.9l18.652,3.364a1.106,1.106,0,0,0,.643-2.1l-15.9-7.021Z",
    transform: "translate(-139.361 -213.936)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39223",
    "data-name": "Path 39223",
    d: "M317.514,446.244a1.324,1.324,0,1,1-1.226,1.415,1.324,1.324,0,0,1,1.226-1.415",
    transform: "translate(-155.5 -219.392)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39224",
    "data-name": "Path 39224",
    d: "M317.567,445.773a1.228,1.228,0,1,1-1.137,1.313,1.227,1.227,0,0,1,1.137-1.313",
    transform: "translate(-155.57 -219.161)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39225",
    "data-name": "Path 39225",
    d: "M317.782,445.774a.988.988,0,1,1-.915,1.056.988.988,0,0,1,.915-1.056",
    transform: "translate(-155.785 -219.161)",
    fill: "#29bef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39226",
    "data-name": "Path 39226",
    d: "M309.349,518.094l-1.191.58-9.768,4.759-1.191.58c-.585-2.428.99-5.335,3.91-6.9,3.123-1.672,6.676-1.211,8.239.979",
    transform: "translate(-146.058 -253.741)",
    fill: "#009edd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39227",
    "data-name": "Path 39227",
    d: "M309.364,519.722l-9.768,4.759c-.375-1.933.9-4.2,3.2-5.428,2.467-1.321,5.262-1,6.572.669",
    transform: "translate(-147.263 -254.789)",
    fill: "#3cc1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39228",
    "data-name": "Path 39228",
    d: "M272.451,488.135a46.347,46.347,0,0,0-21.149,15.4,1.107,1.107,0,0,1-1.621.141l-4.136-3.76a1.106,1.106,0,0,1-.142-1.485,51.508,51.508,0,0,1,24-17.475,1.106,1.106,0,0,1,1.37.592l2.308,5.091a1.107,1.107,0,0,1-.632,1.5",
    transform: "translate(-120.542 -236.428)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13138",
    "data-name": "Group 13138",
    transform: "translate(124.638 244.463)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13137",
    "data-name": "Group 13137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13136",
    "data-name": "Group 13136",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39229",
    "data-name": "Path 39229",
    d: "M245.566,499.932a1.1,1.1,0,0,1,.125-1.109,51.509,51.509,0,0,1,24-17.474,1.094,1.094,0,0,1,1.093.221l-.012-.025a1.1,1.1,0,0,0-1.37-.592,51.506,51.506,0,0,0-24,17.475,1.105,1.105,0,0,0,.142,1.485l.021.019",
    transform: "translate(-245.18 -480.891)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39230",
    "data-name": "Path 39230",
    d: "M281.378,505.37a42.006,42.006,0,0,0-19.169,13.955,1,1,0,0,1-1.469.128l-3.749-3.409a1,1,0,0,1-.129-1.346,46.685,46.685,0,0,1,21.755-15.838,1,1,0,0,1,1.242.536l2.092,4.614a1,1,0,0,1-.573,1.359",
    transform: "translate(-126.186 -245.235)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13141",
    "data-name": "Group 13141",
    transform: "translate(130.475 253.569)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13140",
    "data-name": "Group 13140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13139",
    "data-name": "Group 13139",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39231",
    "data-name": "Path 39231",
    d: "M257.011,516.062a.994.994,0,0,1,.113-1,46.686,46.686,0,0,1,21.755-15.838.992.992,0,0,1,.991.2l-.01-.023a1,1,0,0,0-1.242-.536A46.688,46.688,0,0,0,256.863,514.7a1,1,0,0,0,.129,1.346l.019.017",
    transform: "translate(-256.661 -498.804)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39232",
    "data-name": "Path 39232",
    d: "M223.562,378.554a47.542,47.542,0,0,1,2.615,4.947c.565,1.227,1.1,2.481,1.629,3.744,6.109,14.724-1.8,21.186-1.8,21.186s-1.418,4.068-.954,7.19c-2.444,3.028-27.244,22.742-27.244,22.742a23.575,23.575,0,0,1-5.072-.651,36.006,36.006,0,0,1-13.411-6.191c-.338-.248-.676-.506-1.016-.771-.006,0-.009-.01-.016-.014a45.3,45.3,0,0,1-10.81-12.53c-2.805-4.687-6.818-16.164-8.7-22.547a7.474,7.474,0,0,1,3.332-8.529L196.1,366.8a13.746,13.746,0,0,1,4.093-1.623,12.706,12.706,0,0,1,6.585.237c.891.283,2.56.949,3.4,1.293a27.872,27.872,0,0,1,13.384,11.849",
    transform: "translate(-77.914 -179.378)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13144",
    "data-name": "Group 13144",
    transform: "translate(114.823 204.123)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13143",
    "data-name": "Group 13143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13142",
    "data-name": "Group 13142",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39233",
    "data-name": "Path 39233",
    d: "M259.311,401.536c.565,1.227,1.1,2.481,1.629,3.744,6.109,14.724-1.8,21.186-1.8,21.186s-1.417,4.068-.954,7.19c-2.444,3.028-27.243,22.742-27.243,22.742a23.538,23.538,0,0,1-5.072-.651h0c17.075-8.417,4.873-19.67,4.873-19.67s15.85-12.422,16.514-19.613,12.051-14.928,12.051-14.928",
    transform: "translate(-225.871 -401.536)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13147",
    "data-name": "Group 13147",
    transform: "translate(92.221 188.97)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13146",
    "data-name": "Group 13146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13145",
    "data-name": "Group 13145",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39234",
    "data-name": "Path 39234",
    d: "M183.565,395.41c2.04,15.908,4.882,22.249,6.22,24.469a45.309,45.309,0,0,1-6.66-15.149c-1.307-5.3-1.779-17.453-1.708-24.107a7.474,7.474,0,0,1,5.686-7.177l6.966-1.716c-2.771.816-12.889,5.089-10.5,23.681",
    transform: "translate(-181.41 -371.729)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39235",
    "data-name": "Path 39235",
    d: "M228.6,402.184a19.852,19.852,0,1,1-27.229-6.842,19.852,19.852,0,0,1,27.229,6.842",
    transform: "translate(-94.253 -192.982)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39236",
    "data-name": "Path 39236",
    d: "M229.517,414.613a11.458,11.458,0,1,1-15.716-3.949,11.458,11.458,0,0,1,15.716,3.949",
    transform: "translate(-102.373 -201.101)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13150",
    "data-name": "Group 13150",
    transform: "translate(120.134 185.474)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13149",
    "data-name": "Group 13149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13148",
    "data-name": "Group 13148",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39237",
    "data-name": "Path 39237",
    d: "M261.833,378.554c-4.737-4.562-11.471-9.741-16.085-11.019a17.935,17.935,0,0,0-9.429-.143,3.929,3.929,0,0,0,2.141-2.217,12.706,12.706,0,0,1,6.585.237c.891.283,2.56.949,3.4,1.293a27.872,27.872,0,0,1,13.384,11.849",
    transform: "translate(-236.319 -364.852)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39238",
    "data-name": "Path 39238",
    d: "M229.677,416.787a9.991,9.991,0,1,1-13.7-3.443,9.991,9.991,0,0,1,13.7,3.443",
    transform: "translate(-103.792 -202.521)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39239",
    "data-name": "Path 39239",
    d: "M151.258,237.384c4.048,8.246-3.586,20.289-17.052,26.9s-27.664,5.285-31.712-2.96,3.586-20.289,17.052-26.9,27.664-5.285,31.712,2.96",
    transform: "translate(-49.857 -113.185)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13153",
    "data-name": "Group 13153",
    transform: "translate(52.826 117.033)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13152",
    "data-name": "Group 13152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13151",
    "data-name": "Group 13151",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39240",
    "data-name": "Path 39240",
    d: "M145.74,231.59c-6.41-2.477-15.854-1.637-24.962,2.835-8.279,4.065-14.352,10.183-16.863,16.209a79.754,79.754,0,0,1,18.51-12.426c8.413-4.13,14.122-5.272,21.8-6.187a5.338,5.338,0,0,0,1.512-.431",
    transform: "translate(-103.915 -230.219)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39241",
    "data-name": "Path 39241",
    d: "M144.1,227.548a.267.267,0,0,1,.036.474,6.753,6.753,0,0,1-2.964,1.258c-7.681.915-13.39,2.057-21.8,6.187A77.871,77.871,0,0,0,98.72,249.932a.333.333,0,0,1-.574-.3c2.494-7.989,9.008-15.564,18.295-20.123a37.682,37.682,0,0,1,17.283-3.968,29.781,29.781,0,0,1,10.374,2.01",
    transform: "translate(-48.245 -110.881)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39242",
    "data-name": "Path 39242",
    d: "M155.375,242.3c.1.207.2.416.294.623,5.394,12.037-2.225,27.557-17.31,34.964-15.348,7.535-32.611,3.817-38.56-8.3a20.943,20.943,0,0,1-1.273-14.63,75.457,75.457,0,0,1,21.155-15.114c8.247-4.049,13.842-5.167,21.373-6.065a7.12,7.12,0,0,0,3.305-1.52q.728.3,1.426.65h0v0a20.948,20.948,0,0,1,8.581,7.592c.077.121.152.24.223.364.04.066.081.134.118.2.237.4.458.812.664,1.234",
    transform: "translate(-48.07 -114.187)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39243",
    "data-name": "Path 39243",
    d: "M169.7,241.7c-6.969,3.106-40.358,15.3-41.44,15.7.922-.4,25.789-11.138,31.525-15.426,5.751-4.3,1.144-8.3.993-8.432a20.952,20.952,0,0,1,8.581,7.592c.076.121.152.24.223.364.04.066.081.134.118.2",
    transform: "translate(-63.057 -114.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39244",
    "data-name": "Path 39244",
    d: "M217.559,274.768c1.72,3.5,3.384,7.237,4.949,11.114.083.2.163.394.242.593l.378.939-10.537,5.944c-.069.039-.139.076-.21.111a3.751,3.751,0,0,1-5.061-1.557l-9.958-20.283a3.75,3.75,0,0,1,1.863-4.956q.107-.053.217-.1l10.5-4.427.544.732c.153.206.305.416.457.625a76.029,76.029,0,0,1,6.621,11.265",
    transform: "translate(-96.859 -128.883)",
    fill: "#0a0b0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39245",
    "data-name": "Path 39245",
    d: "M232.956,337.2s2.508-7.171,4.626-8.835,6.924,1.742,7.317,1.571-4.031-7.148-7.25-7.41-9.2,5.108-9.173,7,4.48,7.673,4.48,7.673",
    transform: "translate(-112.329 -158.565)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39246",
    "data-name": "Path 39246",
    d: "M244.926,329.942s-4.386-3.884-6.936-2.943-2.895,7.695-3.754,9.615-3.425.526-3.768-2.27,4.062-10.672,7.532-10.534,6.926,6.132,6.926,6.132",
    transform: "translate(-113.299 -159.199)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13156",
    "data-name": "Group 13156",
    transform: "translate(116.897 164.093)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13155",
    "data-name": "Group 13155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13154",
    "data-name": "Group 13154",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39247",
    "data-name": "Path 39247",
    d: "M244.429,328.928s-4.386-3.884-6.936-2.943-2.895,7.695-3.754,9.615-3.425.526-3.768-2.27,4.063-10.672,7.532-10.534,6.926,6.132,6.926,6.132",
    transform: "translate(-229.952 -322.793)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39248",
    "data-name": "Path 39248",
    d: "M178.1,292.9c-11.526-11.28-9.08,7.059-10.935,8.7-3.954,3.5-7.739,4.964-20.154,9.119a78.935,78.935,0,0,1-9,2.462s0,0-.005,0c-14.43,3-21.315-.438-21.315-.438a47.757,47.757,0,0,1-15.371-17.422,86.831,86.831,0,0,1-5.693-18.181,11.347,11.347,0,0,1-.161-1.547v0c-.065-2.144.592-4.137,2.685-5.164l4.932-1.947,47.784-18.868.7-.276c2.593-1.273,5.167-.023,6.86,2.106.348.438.7.874,1.065,1.316.49.6.992,1.21,1.516,1.862a.851.851,0,0,1-.388,1.3l-7.8,3.292c-.069.029-.139.06-.206.094a3.57,3.57,0,0,0-1.773,4.717l9.468,19.286a3.571,3.571,0,0,0,4.816,1.482c.067-.033.135-.069.2-.106l8.1-4.571a.879.879,0,0,1,1.235.394c1.452,2.952,8.368,17.212,3.442,12.389",
    transform: "translate(-46.937 -122.336)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39249",
    "data-name": "Path 39249",
    d: "M175.574,294.891A14.926,14.926,0,1,1,155.6,288.07a14.926,14.926,0,0,1,19.977,6.821",
    transform: "translate(-72.392 -140.876)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39250",
    "data-name": "Path 39250",
    d: "M175.628,295.994a14.143,14.143,0,1,1-18.928-6.463,14.143,14.143,0,0,1,18.928,6.463",
    transform: "translate(-73.15 -141.634)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39251",
    "data-name": "Path 39251",
    d: "M175.658,296.585a13.724,13.724,0,1,1-18.367-6.271,13.723,13.723,0,0,1,18.367,6.271",
    transform: "translate(-73.556 -142.039)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39252",
    "data-name": "Path 39252",
    d: "M175.8,299.424a11.706,11.706,0,1,1-15.667-5.349,11.706,11.706,0,0,1,15.667,5.349",
    transform: "translate(-75.507 -143.99)",
    fill: "#0084b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39253",
    "data-name": "Path 39253",
    d: "M175.822,299.9a11.369,11.369,0,1,1-15.216-5.195,11.369,11.369,0,0,1,15.216,5.195",
    transform: "translate(-75.834 -144.317)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39254",
    "data-name": "Path 39254",
    d: "M175.876,301a10.584,10.584,0,1,1-14.165-4.836A10.584,10.584,0,0,1,175.876,301",
    transform: "translate(-76.593 -145.076)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39255",
    "data-name": "Path 39255",
    d: "M175.921,301.909a9.942,9.942,0,1,1-13.306-4.543,9.942,9.942,0,0,1,13.306,4.543",
    transform: "translate(-77.214 -145.697)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39256",
    "data-name": "Path 39256",
    d: "M172.549,306.723c1.928,3.927,3.821,6.948-.106,8.875a7.921,7.921,0,1,1-6.981-14.22c3.927-1.928,5.159,1.418,7.087,5.344",
    transform: "translate(-79.17 -147.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39257",
    "data-name": "Path 39257",
    d: "M221.984,276.08c1.72,3.5,3.384,7.237,4.949,11.114l-3.994,2.254-3.811,2.15a2.445,2.445,0,0,1-3.421-.939l-9.469-19.286a2.445,2.445,0,0,1,1.35-3.281l1.47-.619,6.305-2.657a76.029,76.029,0,0,1,6.621,11.265",
    transform: "translate(-101.284 -130.195)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13159",
    "data-name": "Group 13159",
    transform: "translate(104.727 135.174)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13158",
    "data-name": "Group 13158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13157",
    "data-name": "Group 13157",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39258",
    "data-name": "Path 39258",
    d: "M222.939,289.984l-3.811,2.15a2.445,2.445,0,0,1-3.421-.939l-9.469-19.286a2.445,2.445,0,0,1,1.349-3.281l1.47-.619,6.008-2.1s8.463,16.442,7.873,24.079",
    transform: "translate(-206.011 -265.905)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39259",
    "data-name": "Path 39259",
    d: "M219.02,290.919c-.036.02-.073.039-.11.057a1.89,1.89,0,0,1-2.573-.627l-9.469-19.286a1.89,1.89,0,0,1,1.078-2.419c.038-.018.075-.036.114-.052l7.656-3.285c-.117-.165-.234-.329-.352-.493l-7.775,3.277a2.446,2.446,0,0,0-1.35,3.281l9.469,19.286a2.445,2.445,0,0,0,3.421.939l7.8-4.4c-.074-.184-.149-.365-.224-.548Z",
    transform: "translate(-101.284 -130.195)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39260",
    "data-name": "Path 39260",
    d: "M138.01,332.2c-14.43,3-21.315-.438-21.315-.438a47.756,47.756,0,0,1-15.371-17.423,86.822,86.822,0,0,1-5.693-18.181,11.428,11.428,0,0,1-.161-1.547v0c-.065-2.144.593-4.137,2.685-5.164l4.932-1.947s-8.712,5.651-2.224,19.884S117.857,334.14,138.01,332.2",
    transform: "translate(-46.936 -141.345)",
    fill: "#cfd0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39261",
    "data-name": "Path 39261",
    d: "M295.367,517.03c2.671,5.491-.906,24.164-.906,24.164s-.569.26-1.505.7c-2.784,1.294-8.829,4.3-13.945,6.214-4.445,1.665-13.334,2.869-19.19,3.522h0c-3.322.372-5.668.565-5.668.565l-12.521-19.727a10.025,10.025,0,0,1,2.328-11.853l.022-.02a10.024,10.024,0,0,1,2.279-1.523l31.482-15.315s11.542.767,17.627,13.275",
    transform: "translate(-118.298 -247.669)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13162",
    "data-name": "Group 13162",
    transform: "translate(153.043 256.086)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13161",
    "data-name": "Group 13161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13160",
    "data-name": "Group 13160",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39262",
    "data-name": "Path 39262",
    d: "M325.082,517.03c2.671,5.491-.906,24.164-.906,24.164s-.569.26-1.505.7c0,0,.952-18.6-2.057-23.191-4.267-6.508-17.243-10.979-19.558-11.833l6.4-3.113s11.542.767,17.627,13.275",
    transform: "translate(-301.056 -503.755)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39263",
    "data-name": "Path 39263",
    d: "M289.427,547.886a14.55,14.55,0,1,1-5.084-19.939,14.55,14.55,0,0,1,5.084,19.939",
    transform: "translate(-128.99 -258.559)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39264",
    "data-name": "Path 39264",
    d: "M289.427,547.886a14.55,14.55,0,1,1-5.084-19.939,14.55,14.55,0,0,1,5.084,19.939",
    transform: "translate(-128.99 -258.559)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39265",
    "data-name": "Path 39265",
    d: "M293.13,550.083a14.492,14.492,0,0,1-2.909,3.508,13.774,13.774,0,0,1-1.37,1.068A14.554,14.554,0,1,1,273.8,529.8a14.7,14.7,0,0,1,4.879-1.566,14.492,14.492,0,0,1,8.564,1.463c.271.14.541.288.808.447a14.553,14.553,0,0,1,5.81,18.552,14.912,14.912,0,0,1-.727,1.386",
    transform: "translate(-130.81 -259.639)",
    fill: "#272626"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13165",
    "data-name": "Group 13165",
    transform: "translate(139.503 268.463)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13164",
    "data-name": "Group 13164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13163",
    "data-name": "Group 13163",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39266",
    "data-name": "Path 39266",
    d: "M292.958,556.3a14.448,14.448,0,0,1-4.129,1.954L274.42,534.02a14.514,14.514,0,0,1,3.483-2.578Z",
    transform: "translate(-274.42 -529.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39267",
    "data-name": "Path 39267",
    d: "M305.324,550.083a14.491,14.491,0,0,1-2.909,3.508l-11.546-25.356a14.492,14.492,0,0,1,8.564,1.463l6.618,19a14.912,14.912,0,0,1-.727,1.386",
    transform: "translate(-282.507 -528.102)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39268",
    "data-name": "Path 39268",
    d: "M293.474,551.549A11.345,11.345,0,1,1,289.51,536a11.345,11.345,0,0,1,3.964,15.547",
    transform: "translate(-133.91 -262.74)",
    fill: "#3a3939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39269",
    "data-name": "Path 39269",
    d: "M285.724,540.212a4.649,4.649,0,0,0-2,1.538l-4.984,6.8,5.2,6.637a4.653,4.653,0,0,0,2.046,1.473s21.053,5.5,28.261,6.223c5.257.529,21.144-.335,21.144-.335s6.4-7.085,6.276-14.995-6.747-14.788-6.747-14.788-15.906-.361-21.144.334c-7.182.953-28.051,7.114-28.051,7.114",
    transform: "translate(-137.042 -261.885)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39270",
    "data-name": "Path 39270",
    d: "M285.656,535.906a4.645,4.645,0,0,0-2,1.538l-4.984,6.8,5.2,6.637a4.653,4.653,0,0,0,2.046,1.473s21.053,5.5,28.261,6.223c5.257.529,21.144-.335,21.144-.335s6.4-7.085,6.276-14.994-6.747-14.789-6.747-14.789-15.906-.361-21.144.334c-7.182.953-28.051,7.114-28.051,7.114",
    transform: "translate(-137.008 -259.768)",
    fill: "#4f5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39271",
    "data-name": "Path 39271",
    d: "M278.674,559.6l.035,2.189,1.119,1.429.486-1.523Z",
    transform: "translate(-137.009 -275.123)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39272",
    "data-name": "Path 39272",
    d: "M372.439,515.055a19.828,19.828,0,1,1-19.512,20.139,19.828,19.828,0,0,1,19.512-20.139",
    transform: "translate(-173.514 -253.223)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39273",
    "data-name": "Path 39273",
    d: "M373.351,516.881a18.9,18.9,0,1,1-18.6,19.2,18.9,18.9,0,0,1,18.6-19.2",
    transform: "translate(-174.411 -254.121)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39274",
    "data-name": "Path 39274",
    d: "M375.643,521.466a16.569,16.569,0,1,1-16.3,16.829,16.568,16.568,0,0,1,16.3-16.829",
    transform: "translate(-176.666 -256.375)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39275",
    "data-name": "Path 39275",
    d: "M285.578,530.949a4.648,4.648,0,0,0-2,1.538l-4.984,6.8,5.2,6.637a4.653,4.653,0,0,0,2.046,1.473s21.053,5.5,28.261,6.223c5.257.529,21.144-.334,21.144-.334s6.4-7.085,6.276-14.995-6.747-14.788-6.747-14.788-15.906-.361-21.144.335c-7.182.953-28.051,7.114-28.051,7.114",
    transform: "translate(-136.97 -257.331)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39276",
    "data-name": "Path 39276",
    d: "M285.509,526.643a4.647,4.647,0,0,0-2,1.538l-4.984,6.8,5.2,6.637a4.647,4.647,0,0,0,2.046,1.473s21.053,5.5,28.261,6.223c5.258.529,21.144-.335,21.144-.335s6.4-7.085,6.276-14.994-6.747-14.789-6.747-14.789-15.906-.361-21.145.335c-7.182.953-28.05,7.114-28.05,7.114",
    transform: "translate(-136.936 -255.214)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39277",
    "data-name": "Path 39277",
    d: "M278.527,550.334l.035,2.189,1.119,1.429.486-1.523Z",
    transform: "translate(-136.937 -270.569)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39278",
    "data-name": "Path 39278",
    d: "M518.354,634.566l-47.5,40.725-7.988-14.216-5.248-9.341-6.3-11.218,37.2-32.422,6.251,5.545,4.343,3.854Z",
    transform: "translate(-221.887 -298.966)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39279",
    "data-name": "Path 39279",
    d: "M585.56,621.9l-3.344,9.622L594.9,648.415l-5.472,4.768S576.1,637.026,575.958,636.86s-1.288-7.569-1.288-7.569l4.769-4.506,2.44-1.149Z",
    transform: "translate(-282.534 -305.755)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39280",
    "data-name": "Path 39280",
    d: "M581.879,625.312l-4.157,5.943,4.222,10.115,9.911,11.372-2.429,2.117S576.1,638.7,575.959,638.536s-1.288-7.569-1.288-7.569l4.769-4.505Z",
    transform: "translate(-282.534 -307.432)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39281",
    "data-name": "Path 39281",
    d: "M474.211,691.184l3.335,4.882,40.719-35.735,5.237-24.749-5.644,2.527-11.874,24.7Z",
    transform: "translate(-233.144 -312.481)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13168",
    "data-name": "Group 13168",
    transform: "translate(235.733 314.671)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13167",
    "data-name": "Group 13167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13166",
    "data-name": "Group 13166",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39282",
    "data-name": "Path 39282",
    d: "M505.21,622.854,496.73,642.24l-27.764,24.2-5.248-9.342L500.866,619Z",
    transform: "translate(-463.717 -619)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39283",
    "data-name": "Path 39283",
    d: "M469.888,580.3l-6.2,14.033-.6,1.361-2.766,6.266.938.42.419.186-11.5,10.02-1.054-1.21-17.861,15.566-37.493-59.764.01-.008c-4.623-5.894-2.035-16.08,5.963-23.051a26.766,26.766,0,0,1,5.605-3.775q.66-.333,1.33-.617c6.372-2.729,12.927-2.279,16.715,1.635l.008-.007,46.471,38.932.014.012",
    transform: "translate(-192.478 -264.504)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39284",
    "data-name": "Path 39284",
    d: "M548.786,630.446l-14.793,12.892,8.2-18.42Z",
    transform: "translate(-262.536 -307.238)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39285",
    "data-name": "Path 39285",
    d: "M511.165,657.975,470.287,693.6l-1.823-3.055,1.327-12.467,18.983-16.544-.752-.863,11.5-10.02,1.153.513,1.1-2.481,14.793-12.892Z",
    transform: "translate(-230.318 -312.585)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39286",
    "data-name": "Path 39286",
    d: "M531.885,624.733,527.3,631.3l4.33,10.491,11.322,13.192L484.242,706.15,475,690.676l41.7-36.343,6.257-25.455Z",
    transform: "translate(-233.533 -307.147)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39287",
    "data-name": "Path 39287",
    d: "M623.883,627.142l-26.212,22.844-10.319-11.84-4.642-10.97,5.332-7.392,4.5-2.092Z",
    transform: "translate(-286.487 -303.685)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13171",
    "data-name": "Group 13171",
    transform: "translate(214.203 273.493)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13170",
    "data-name": "Group 13170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13169",
    "data-name": "Group 13169",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39288",
    "data-name": "Path 39288",
    d: "M484.573,580.3l-6.2,14.033-57.007-54.606c6.372-2.729,12.927-2.279,16.715,1.635l.008-.007,46.471,38.932.014.012",
    transform: "translate(-421.366 -537.997)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39289",
    "data-name": "Path 39289",
    d: "M460.32,604.24l.938.42-.59,1.065-10.488,9.14-1.054-1.21-17.861,15.566-37.493-59.764.01-.008c-4.623-5.894-2.035-16.08,5.963-23.051a26.75,26.75,0,0,1,5.605-3.775l57.734,55.35Z",
    transform: "translate(-192.478 -266.779)",
    fill: "#bfc1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39290",
    "data-name": "Path 39290",
    d: "M515.3,660.79a9.2,9.2,0,1,1-12.983-.892,9.2,9.2,0,0,1,12.983.892",
    transform: "translate(-245.408 -323.323)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39291",
    "data-name": "Path 39291",
    d: "M515.668,663.618a7.462,7.462,0,1,1-10.528-.723,7.462,7.462,0,0,1,10.528.723",
    transform: "translate(-247.092 -325.006)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39292",
    "data-name": "Path 39292",
    d: "M515.99,666.073a5.95,5.95,0,1,1-8.395-.577,5.95,5.95,0,0,1,8.395.577",
    transform: "translate(-248.554 -326.469)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39293",
    "data-name": "Path 39293",
    d: "M476.119,694.609l39.638-34.671,4.948-21.4-1.224.548-4.931,20.239-39.2,34.161Z",
    transform: "translate(-233.705 -313.935)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39294",
    "data-name": "Path 39294",
    d: "M508.409,747.661l-1.428,1.245L499.4,743.75l-4.071-8.214,1.428-1.245,4.072,8.214Z",
    transform: "translate(-243.526 -361.01)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39295",
    "data-name": "Path 39295",
    d: "M495.758,736l-.431.376,4.072,8.215,7.581,5.156.431-.376-7.581-5.156Z",
    transform: "translate(-243.525 -361.851)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39296",
    "data-name": "Path 39296",
    d: "M565.86,697.593l1.428-1.245-4.072-8.214-7.581-5.156-1.429,1.245,7.581,5.156Z",
    transform: "translate(-272.473 -335.783)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39297",
    "data-name": "Path 39297",
    d: "M556.169,683.353l.431-.376,7.581,5.156,4.072,8.214-.431.376-4.072-8.214Z",
    transform: "translate(-273.438 -335.783)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13174",
    "data-name": "Group 13174",
    transform: "translate(226.603 247.39)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13173",
    "data-name": "Group 13173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13172",
    "data-name": "Group 13172",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39298",
    "data-name": "Path 39298",
    d: "M458.8,486.648s2.543,6.882.14,10.27c-1.925,2.713-3.722,5.239-3.949,5.533a4.509,4.509,0,0,1-1.174.714c-2.057,1.015-7.628-.325-7.852-.745-.29-.546-.536-3.223,1.153-3.525,1.334-.239,2.75,1.12,3.876.577a2.715,2.715,0,0,0,.594-.343c.164-.167,1.777-2.371,3.568-4.838,2.393-3.3-.864-7.278-.864-7.278Z",
    transform: "translate(-445.757 -486.648)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39299",
    "data-name": "Path 39299",
    d: "M458.847,488.475c.174,2.086,1.8,6.618.228,8.838-1.912,2.694-3.607,5.076-3.9,5.47a6.538,6.538,0,0,1-1.036.581c-1.651.8-5.636-.244-6.623-.619a3.085,3.085,0,0,1,.156-1.762.572.572,0,0,1,.435-.34c.908-.163,2.429.614,3.075.552a3.691,3.691,0,0,0,1.131-.109,2.563,2.563,0,0,0,.725-.452c.191-.193,1.78-2.361,3.6-4.871,1.648-2.269-.442-5.069-.589-7.061Z",
    transform: "translate(-219.989 -240.157)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39300",
    "data-name": "Path 39300",
    d: "M446.014,509.288a1.285,1.285,0,0,0-.6-.3,23.793,23.793,0,0,0-4.3-.622c-2.3.206-3.4,3.649-1.684,4.582a45.972,45.972,0,0,0,4.692,1.388,4.258,4.258,0,0,0,.891.172,26.566,26.566,0,0,0,1-5.215",
    transform: "translate(-215.631 -249.933)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13177",
    "data-name": "Group 13177",
    transform: "translate(228.489 259.05)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13176",
    "data-name": "Group 13176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13175",
    "data-name": "Group 13175",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39301",
    "data-name": "Path 39301",
    d: "M451.361,509.89a1.286,1.286,0,0,0-.6-.305,14.965,14.965,0,0,1-1.3,5.348,4.256,4.256,0,0,0,.891.172,26.571,26.571,0,0,0,1-5.215",
    transform: "translate(-449.467 -509.585)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39302",
    "data-name": "Path 39302",
    d: "M456.575,506.964c.5-.692,1.743-2.378,2.455-3.275a4.465,4.465,0,0,1,.5-.581c.228-.12,4.31,3.289,4.31,3.289s-.176.254-.451.649c-.747,1.068-2.231,3.159-2.963,4a1.386,1.386,0,0,1-.385.358s-3.817-3.918-3.678-4.14c.02-.031.1-.137.21-.3",
    transform: "translate(-224.368 -247.349)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39303",
    "data-name": "Path 39303",
    d: "M462.127,495.813a1.7,1.7,0,0,1-.313-.656,30.635,30.635,0,0,1-.908-5.555c-.026-.446-.015-.725.048-.726,1.432-.018,5-.175,5.722-.325.142-.031.258.2.351.6a29.934,29.934,0,0,1,.346,5.364,3.005,3.005,0,0,1-.044.654,21.919,21.919,0,0,1-5.2.643",
    transform: "translate(-226.595 -240.192)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13180",
    "data-name": "Group 13180",
    transform: "translate(234.297 248.356)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13179",
    "data-name": "Group 13179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13178",
    "data-name": "Group 13178",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39304",
    "data-name": "Path 39304",
    d: "M467.026,489.152a24.834,24.834,0,0,1-6.121.449c-.026-.446-.014-.725.048-.726,1.432-.018,5-.175,5.722-.324.142-.031.258.2.351.6",
    transform: "translate(-460.892 -488.548)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13183",
    "data-name": "Group 13183",
    transform: "translate(235.219 254.323)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13182",
    "data-name": "Group 13182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13181",
    "data-name": "Group 13181",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39305",
    "data-name": "Path 39305",
    d: "M463.018,501.585a1.7,1.7,0,0,1-.313-.656,14.253,14.253,0,0,0,5.558-.641,3,3,0,0,1-.044.654,21.918,21.918,0,0,1-5.2.643",
    transform: "translate(-462.706 -500.288)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13186",
    "data-name": "Group 13186",
    transform: "translate(231.993 259.615)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13185",
    "data-name": "Group 13185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13184",
    "data-name": "Group 13184",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39306",
    "data-name": "Path 39306",
    d: "M456.575,510.7a12.785,12.785,0,0,1,3.852,4.079,1.386,1.386,0,0,1-.385.358s-3.817-3.918-3.678-4.14c.02-.032.1-.137.21-.3",
    transform: "translate(-456.36 -510.696)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13189",
    "data-name": "Group 13189",
    transform: "translate(234.662 255.756)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13188",
    "data-name": "Group 13188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13187",
    "data-name": "Group 13187",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39307",
    "data-name": "Path 39307",
    d: "M461.612,503.689a4.38,4.38,0,0,1,.5-.581c.228-.12,4.31,3.289,4.31,3.289s-.175.254-.451.649a29.7,29.7,0,0,0-4.36-3.357",
    transform: "translate(-461.612 -503.105)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39308",
    "data-name": "Path 39308",
    d: "M459.852,488.791s3.348,6.528,1.367,10.179c-1.587,2.924-3.069,5.646-3.259,5.966a4.5,4.5,0,0,1-1.08.849c-1.921,1.253-7.612.589-7.885.2-.353-.507-.917-3.135.723-3.637,1.3-.4,2.865.783,3.918.109a2.688,2.688,0,0,0,.548-.411c.143-.185,1.481-2.566,2.964-5.23,1.982-3.559-1.728-7.123-1.728-7.123Z",
    transform: "translate(-220.556 -240.312)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39309",
    "data-name": "Path 39309",
    d: "M460.015,490.789c.422,2.05,2.582,6.354,1.284,8.747-1.576,2.9-2.974,5.471-3.22,5.9a6.491,6.491,0,0,1-.959.7c-1.543.989-5.624.432-6.65.177a3.088,3.088,0,0,1-.056-1.768.573.573,0,0,1,.392-.39c.881-.27,2.485.319,3.119.18a3.686,3.686,0,0,0,1.11-.243,2.558,2.558,0,0,0,.665-.535c.166-.214,1.485-2.557,2.995-5.267,1.365-2.45-1.045-4.98-1.429-6.94Z",
    transform: "translate(-221.39 -241.294)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39310",
    "data-name": "Path 39310",
    d: "M448.543,513.962a1.287,1.287,0,0,0-.63-.231,23.759,23.759,0,0,0-4.346-.1c-2.26.479-2.939,4.03-1.125,4.75a45.809,45.809,0,0,0,4.824.817,4.271,4.271,0,0,0,.906.064,26.618,26.618,0,0,0,.371-5.3",
    transform: "translate(-217.014 -252.496)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13192",
    "data-name": "Group 13192",
    transform: "translate(230.253 261.235)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13191",
    "data-name": "Group 13191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13190",
    "data-name": "Group 13190",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39311",
    "data-name": "Path 39311",
    d: "M454.214,514.114a1.287,1.287,0,0,0-.63-.231,14.959,14.959,0,0,1-.647,5.464,4.276,4.276,0,0,0,.906.064,26.614,26.614,0,0,0,.371-5.3",
    transform: "translate(-452.938 -513.883)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39312",
    "data-name": "Path 39312",
    d: "M458.9,510.367c.413-.746,1.446-2.569,2.046-3.545a4.416,4.416,0,0,1,.429-.637c.211-.147,4.672,2.75,4.672,2.75s-.144.273-.371.7c-.614,1.149-1.837,3.4-2.464,4.322a1.393,1.393,0,0,1-.339.4s-4.258-3.433-4.147-3.671c.016-.034.078-.147.174-.319",
    transform: "translate(-225.532 -248.861)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39313",
    "data-name": "Path 39313",
    d: "M462.664,498.328a1.693,1.693,0,0,1-.389-.614,30.64,30.64,0,0,1-1.567-5.407c-.079-.44-.1-.718-.04-.727,1.42-.19,4.948-.773,5.642-1.007.138-.048.28.17.421.556a29.914,29.914,0,0,1,.985,5.283,2.975,2.975,0,0,1,.035.655,21.929,21.929,0,0,1-5.087,1.26",
    transform: "translate(-226.468 -241.185)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13195",
    "data-name": "Group 13195",
    transform: "translate(234.165 249.382)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13194",
    "data-name": "Group 13194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13193",
    "data-name": "Group 13193",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39314",
    "data-name": "Path 39314",
    d: "M466.731,491.129a24.822,24.822,0,0,1-6.023,1.177c-.079-.439-.1-.718-.04-.727,1.42-.189,4.948-.772,5.642-1.006.138-.048.28.17.421.556",
    transform: "translate(-460.633 -490.567)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13198",
    "data-name": "Group 13198",
    transform: "translate(235.806 255.228)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13197",
    "data-name": "Group 13197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13196",
    "data-name": "Group 13196",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39315",
    "data-name": "Path 39315",
    d: "M464.252,503.981a1.693,1.693,0,0,1-.389-.614,14.251,14.251,0,0,0,5.441-1.3,2.973,2.973,0,0,1,.035.655,21.936,21.936,0,0,1-5.087,1.26",
    transform: "translate(-463.863 -502.066)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13201",
    "data-name": "Group 13201",
    transform: "translate(233.197 261.506)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13200",
    "data-name": "Group 13200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13199",
    "data-name": "Group 13199",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39316",
    "data-name": "Path 39316",
    d: "M458.9,514.416A12.791,12.791,0,0,1,463.217,518a1.394,1.394,0,0,1-.339.4s-4.258-3.433-4.147-3.671c.016-.034.078-.147.174-.319",
    transform: "translate(-458.729 -514.416)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13204",
    "data-name": "Group 13204",
    transform: "translate(235.419 257.318)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13203",
    "data-name": "Group 13203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13202",
    "data-name": "Group 13202",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39317",
    "data-name": "Path 39317",
    d: "M463.1,506.821a4.489,4.489,0,0,1,.429-.637c.211-.146,4.672,2.751,4.672,2.751s-.144.272-.371.7a29.6,29.6,0,0,0-4.73-2.812",
    transform: "translate(-463.1 -506.179)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39318",
    "data-name": "Path 39318",
    d: "M465.885,487.028s4.912,5.45,3.935,9.487c-.782,3.234-1.515,6.245-1.618,6.6a4.517,4.517,0,0,1-.826,1.1c-1.535,1.7-7.205,2.525-7.569,2.217-.472-.4-1.691-2.794-.235-3.7,1.15-.716,2.969.021,3.814-.9a2.69,2.69,0,0,0,.424-.538c.091-.216.772-2.861,1.522-5.816,1-3.948-3.5-6.44-3.5-6.44Z",
    transform: "translate(-225.607 -239.445)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39319",
    "data-name": "Path 39319",
    d: "M466.331,489.3c.934,1.873,4.127,5.479,3.487,8.124-.778,3.211-1.47,6.051-1.6,6.527a6.552,6.552,0,0,1-.748.924c-1.237,1.352-5.325,1.861-6.381,1.878a3.083,3.083,0,0,1-.508-1.693.573.573,0,0,1,.278-.478c.783-.487,2.484-.329,3.061-.627a3.7,3.7,0,0,0,1.01-.52,2.587,2.587,0,0,0,.506-.688c.106-.25.778-2.853,1.542-5.86.69-2.718-2.289-4.545-3.164-6.34Z",
    transform: "translate(-226.44 -240.561)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39320",
    "data-name": "Path 39320",
    d: "M458.331,515.571a1.284,1.284,0,0,0-.668-.061,23.73,23.73,0,0,0-4.227,1.017c-2.061,1.043-1.806,4.649.134,4.88a46.078,46.078,0,0,0,4.872-.449,4.318,4.318,0,0,0,.892-.171,26.573,26.573,0,0,0-1-5.215",
    transform: "translate(-222.223 -253.443)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13207",
    "data-name": "Group 13207",
    transform: "translate(235.439 262.056)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13206",
    "data-name": "Group 13206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13205",
    "data-name": "Group 13205",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39321",
    "data-name": "Path 39321",
    d: "M463.809,515.571a1.284,1.284,0,0,0-.669-.061,14.952,14.952,0,0,1,.778,5.447,4.319,4.319,0,0,0,.892-.171,26.578,26.578,0,0,0-1-5.215",
    transform: "translate(-463.14 -515.499)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39322",
    "data-name": "Path 39322",
    d: "M467.9,510.247c.207-.828.738-2.854,1.067-3.951a4.392,4.392,0,0,1,.251-.726c.167-.2,5.221,1.458,5.221,1.458s-.069.3-.179.77c-.3,1.268-.9,3.761-1.271,4.81a1.376,1.376,0,0,1-.225.475s-5-2.225-4.95-2.482c.007-.037.038-.163.086-.353",
    transform: "translate(-229.996 -248.553)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39323",
    "data-name": "Path 39323",
    d: "M467.584,496.893a1.7,1.7,0,0,1-.534-.493,30.614,30.614,0,0,1-2.9-4.823c-.19-.4-.282-.668-.225-.692,1.323-.548,4.584-2.018,5.194-2.421.121-.082.314.092.549.429a29.866,29.866,0,0,1,2.308,4.853,2.974,2.974,0,0,1,.2.624,21.919,21.919,0,0,1-4.592,2.524",
    transform: "translate(-228.077 -240.141)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13210",
    "data-name": "Group 13210",
    transform: "translate(235.829 248.302)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13209",
    "data-name": "Group 13209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13208",
    "data-name": "Group 13208",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39324",
    "data-name": "Path 39324",
    d: "M469.667,488.891a24.853,24.853,0,0,1-5.519,2.685c-.189-.4-.282-.668-.225-.693,1.323-.548,4.584-2.017,5.194-2.421.121-.081.315.092.55.429",
    transform: "translate(-463.907 -488.442)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13213",
    "data-name": "Group 13213",
    transform: "translate(238.973 253.604)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13212",
    "data-name": "Group 13212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13211",
    "data-name": "Group 13211",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39325",
    "data-name": "Path 39325",
    d: "M470.625,502.02a1.7,1.7,0,0,1-.534-.493,14.25,14.25,0,0,0,4.924-2.655,2.976,2.976,0,0,1,.2.624,21.917,21.917,0,0,1-4.592,2.524",
    transform: "translate(-470.092 -498.872)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13216",
    "data-name": "Group 13216",
    transform: "translate(237.813 261.694)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13215",
    "data-name": "Group 13215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13214",
    "data-name": "Group 13214",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M467.9,514.786a12.785,12.785,0,0,1,5.089,2.36,1.377,1.377,0,0,1-.225.475s-5-2.225-4.95-2.482c.007-.037.038-.163.086-.353",
    transform: "translate(-467.81 -514.786)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13219",
    "data-name": "Group 13219",
    transform: "translate(238.966 257)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13218",
    "data-name": "Group 13218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13217",
    "data-name": "Group 13217",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39327",
    "data-name": "Path 39327",
    d: "M470.078,506.3a4.446,4.446,0,0,1,.251-.726c.167-.2,5.221,1.458,5.221,1.458s-.069.3-.179.77a29.614,29.614,0,0,0-5.294-1.5",
    transform: "translate(-470.078 -505.553)",
    fill: "#d6dbdd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39328",
    "data-name": "Path 39328",
    d: "M438.281,492.285l-.661,2.548a5.315,5.315,0,0,1-4,3.856l-13.891,3.057a5.315,5.315,0,0,1-5.139-1.686l-3.288-3.749Z",
    transform: "translate(-202.213 -242.03)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39329",
    "data-name": "Path 39329",
    d: "M409.425,481.384s22.26-4.179,24.439-4.139,8.358,5.782,8.554,6.956-32.5,7.522-32.936,6.588-1.419-8.5-.057-9.406",
    transform: "translate(-200.95 -234.635)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13222",
    "data-name": "Group 13222",
    transform: "translate(122.319 272.923)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13221",
    "data-name": "Group 13221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13220",
    "data-name": "Group 13220",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39330",
    "data-name": "Path 39330",
    d: "M259.817,567.911c-3.322.372-5.668.565-5.668.565l-12.521-19.727a10.025,10.025,0,0,1,2.328-11.853l.022-.02s-3.206,5.962-.047,12.054c3.133,6.044,15.69,18.78,15.886,18.981",
    transform: "translate(-240.617 -536.876)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39331",
    "data-name": "Path 39331",
    d: "M277.151,458.809l17.2,6.112a1.065,1.065,0,0,0,.939-1.9l-15.358-8.771Z",
    transform: "translate(-136.26 -223.333)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39332",
    "data-name": "Path 39332",
    d: "M278.485,457.7l17.2,6.15a1.081,1.081,0,0,0,.737,0,1.064,1.064,0,0,0-.479-.82l-15.358-8.77Z",
    transform: "translate(-136.916 -223.333)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39333",
    "data-name": "Path 39333",
    d: "M300.935,448.113c5.1,3.386,7.249,9.982,4.788,14.733s-8.594,5.858-13.7,2.472-7.249-9.981-4.788-14.732,8.594-5.858,13.7-2.473",
    transform: "translate(-140.717 -219.348)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39334",
    "data-name": "Path 39334",
    d: "M302.337,450.745c4.43,2.955,6.437,8.427,4.482,12.222s-7.132,4.476-11.562,1.521-6.437-8.427-4.482-12.222,7.131-4.476,11.562-1.52",
    transform: "translate(-142.59 -220.703)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39335",
    "data-name": "Path 39335",
    d: "M304,453.251c3.778,2.405,5.351,7.031,3.514,10.331s-6.391,4.027-10.169,1.621-5.352-7.031-3.514-10.331,6.391-4.026,10.169-1.621",
    transform: "translate(-144.084 -222.141)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31641",
    "data-name": "Rectangle 31641",
    width: 25.296,
    height: 12.409,
    transform: "translate(173.228 253.598) rotate(-71.492)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39336",
    "data-name": "Path 39336",
    d: "M329.751,445.506a.817.817,0,0,1,.233,1.426,22.816,22.816,0,0,0-7.942,23.75.817.817,0,0,1-1.046,1L302.531,465.5a13.8,13.8,0,0,1,8.76-26.169Z",
    transform: "translate(-144.106 -215.64)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39337",
    "data-name": "Path 39337",
    d: "M360.153,455.738l5.6,1.873L357.719,481.6l-5.591-1.872c-.018-.052-.033-.1-.046-.148a22.814,22.814,0,0,1,7.941-23.75,1.562,1.562,0,0,1,.13-.091",
    transform: "translate(-172.724 -224.062)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39338",
    "data-name": "Path 39338",
    d: "M363.987,455.269l23.467,8.879s4.263,2.359.472,13.685c-3.678,10.989-8.626,10.675-8.626,10.675l-24.067-7.068a2.911,2.911,0,0,1-1.424-1.822,22.814,22.814,0,0,1,7.941-23.749,3.158,3.158,0,0,1,2.237-.6",
    transform: "translate(-173.573 -223.806)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13225",
    "data-name": "Group 13225",
    transform: "translate(187.601 240.341)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13224",
    "data-name": "Group 13224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13223",
    "data-name": "Group 13223",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39339",
    "data-name": "Path 39339",
    d: "M395.316,472.783s4.263,2.359.472,13.685c-3.678,10.989-8.626,10.675-8.626,10.675a66.869,66.869,0,0,1-18.127-9.893s8.4,3.565,15.842,2.9,10.44-17.364,10.44-17.364",
    transform: "translate(-369.035 -472.783)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39340",
    "data-name": "Path 39340",
    d: "M313.553,449.985a8.143,8.143,0,1,1-10.679-4.312,8.143,8.143,0,0,1,10.679,4.312",
    transform: "translate(-146.467 -218.794)",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39341",
    "data-name": "Path 39341",
    d: "M253.327,428.942c.683,1,1.069,2.605.3,5.414a9.06,9.06,0,0,1-7.247,6.65,11.953,11.953,0,0,1-1.068-1.5c-.108-.177-.2-.353-.3-.527a9.788,9.788,0,0,1-1.219-4.1c1.488-3.667,2.887-5.316,5-5.874a7.961,7.961,0,0,1,2.022-.235,19.843,19.843,0,0,1,2.507.167",
    transform: "translate(-119.86 -210.805)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13228",
    "data-name": "Group 13228",
    transform: "translate(125.12 217.969)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13227",
    "data-name": "Group 13227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13226",
    "data-name": "Group 13226",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39342",
    "data-name": "Path 39342",
    d: "M254.474,428.942c.683,1,1.069,2.605.3,5.414a9.06,9.06,0,0,1-7.247,6.65,11.956,11.956,0,0,1-1.068-1.5c-.108-.177-.2-.353-.3-.527a10.421,10.421,0,0,1,1.13-5.494,10.065,10.065,0,0,1,4.678-4.713,19.842,19.842,0,0,1,2.507.167",
    transform: "translate(-246.127 -428.774)",
    fill: "#121212"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39343",
    "data-name": "Path 39343",
    d: "M230.045,434.162l21.592,7.451,1.156-2.941L230.322,431.2Z",
    transform: "translate(-113.101 -211.997)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39344",
    "data-name": "Path 39344",
    d: "M230.809,426.04l22.737,6.883.993-3L231.082,423.1Z",
    transform: "translate(-113.476 -208.017)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39345",
    "data-name": "Path 39345",
    d: "M256.88,428.481c6.664.982,11.821,6.3,11.821,6.3l-5.562,12.31a22.479,22.479,0,0,1-12.42-3.423,13.606,13.606,0,0,1-3.761-3.7l0-.006a.5.5,0,0,1,.24-.742c1.92-.727,5.07-2.382,6.1-5.629,1.157-3.636-.441-4.648-2.175-5.1a.176.176,0,0,1,.015-.344c.165-.024.335-.042.508-.054h.006a24.6,24.6,0,0,1,5.229.389",
    transform: "translate(-121.372 -210.454)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13231",
    "data-name": "Group 13231",
    transform: "translate(125.497 217.638)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13230",
    "data-name": "Group 13230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13229",
    "data-name": "Group 13229",
    clipPath: "url(#clip-path-55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39346",
    "data-name": "Path 39346",
    d: "M251.645,428.122h.006c1.261.312,3.7,1.459,2.315,5.668A9.618,9.618,0,0,1,246.958,440l0-.005a.5.5,0,0,1,.24-.742c1.92-.727,5.07-2.383,6.1-5.629,1.157-3.636-.441-4.649-2.175-5.1a.175.175,0,0,1,.015-.344c.165-.024.335-.042.508-.054",
    transform: "translate(-246.869 -428.122)",
    fill: "#1d1c1c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39347",
    "data-name": "Path 39347",
    d: "M281.888,446.621l18.144,5.478a1.106,1.106,0,0,0,.879-2.013l-14.993-8.8Z",
    transform: "translate(-138.589 -216.958)",
    fill: "#d6dbdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M315.59,455.593a1.324,1.324,0,1,1-1.38,1.266,1.324,1.324,0,0,1,1.38-1.266",
    transform: "translate(-154.479 -223.99)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39349",
    "data-name": "Path 39349",
    d: "M315.707,455.121a1.228,1.228,0,1,1-1.28,1.174,1.228,1.228,0,0,1,1.28-1.174",
    transform: "translate(-154.586 -223.758)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39350",
    "data-name": "Path 39350",
    d: "M315.95,455.121a.988.988,0,1,1-1.029.944.987.987,0,0,1,1.029-.944",
    transform: "translate(-154.829 -223.758)",
    fill: "#559c33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39351",
    "data-name": "Path 39351",
    d: "M229.155,421.414a4.642,4.642,0,1,1-6.142,2.318,4.642,4.642,0,0,1,6.142-2.318",
    transform: "translate(-109.44 -206.983)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39352",
    "data-name": "Path 39352",
    d: "M229.023,429.5a1.745,1.745,0,1,0-.172-2.461,1.744,1.744,0,0,0,.172,2.461",
    transform: "translate(-112.303 -209.655)",
    fill: "#1d1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39353",
    "data-name": "Path 39353",
    d: "M228.657,430.182a1.618,1.618,0,1,0-.159-2.282,1.618,1.618,0,0,0,.159,2.282",
    transform: "translate(-112.144 -210.101)",
    fill: "#4d4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39354",
    "data-name": "Path 39354",
    d: "M228.762,430.719a1.3,1.3,0,1,0-.129-1.836,1.3,1.3,0,0,0,.129,1.836",
    transform: "translate(-112.25 -210.638)",
    fill: "#559c33"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRobot403);
export default __webpack_public_path__ + "static/media/Error_Robot_403.d4cf4e6c0b349a196f4f721ed191e958.svg";
export { ForwardRef as ReactComponent };